import get from 'lodash/get';

export default id => state =>
  get(state, `programMEA.MEAProgramsByBlockId.${id}`, []);
